import React from "react";

const REDUCER_TYPES = {
  INIT: "INIT",
  CHANGE_CAR_TYPE: "CHANGE_CAR_TYPE",
  CHANGE_VALUE: "CHANGE_VALUE",
  APPLY_EXTERNAL_FILTERS: "APPLY_EXTERNAL_FILTERS",
  FILTERS_CHANGE: "FILTERS_CHANGE",
};

function filterBoxReducer(state, { type, payload }) {
  switch (type) {
    /**
     * Init base
     * 1. No existe ningun
     * 2. Existe algun filtro, lo pasaremos.
     */
    case REDUCER_TYPES.INIT:
      return {
        ...state,
        alreadyInitialize: true,
        options: {
          ...state.options,
          // brands: payload.brands,
          types: payload.types,
        },
      };

    case REDUCER_TYPES.CHANGE_CAR_TYPE:
      return {
        ...state,
        options: {
          ...state.options,
          brands: payload.brands,
          models: [],
        },
        values: {
          ...state.values,
          brand: "all",
          model: "all",
        },
      };
    case REDUCER_TYPES.FILTERS_CHANGE:
      return {
        ...state,
        options: {
          ...state.options,
          ...payload.options,
        },
        values: {
          ...state.values,
          ...payload.values,
        },
      };
    case REDUCER_TYPES.APPLY_EXTERNAL_FILTERS:
      return {
        ...state,
        values: {
          ...state.values,
          [payload.name]: state.options[payload.optionsName].find(
            (r) => r.display === payload.value
          ).value,
        },
      };
    case REDUCER_TYPES.CHANGE_VALUE:
      return {
        ...state,
        values: {
          ...state.values,
          [payload.name]: payload.value,
        },
      };
    default:
      return state;
  }
}

export default function useFilter() {
  const [state, dispatch] = React.useReducer(filterBoxReducer, {
    alreadyInitialize: false,
    options: {
      brands: [],
      models: [],
      years: [],
      prices: [],
      cities: [],
      types: [],
      years: [],
    },
    values: {
      brand: "all",
      model: "all",
      type: "all",
      city: "all",
      "lte-year": "all",
      "gte-year": "all",
      "lte-price": "all",
      "gte-price": "all",
    },
  });

  const changeFilters = React.useCallback(
    (payloadData) => {
      dispatch({
        type: REDUCER_TYPES.FILTERS_CHANGE,
        payload: payloadData,
      });
    },
    [dispatch]
  );

  const changeValue = React.useCallback(
    ({ name, value }) => {
      dispatch({
        type: REDUCER_TYPES.CHANGE_VALUE,
        payload: {
          name,
          value,
        },
      });
    },
    [dispatch]
  );

  return {
    filterValues: state.values,
    filterOptions: state.options,
    changeValue,
    changeFilters,
  };
}
